export default function UsedVsUnused({ used, unused }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Used Features */}
      <div className="bg-green-200/10 border border-green-300/20 rounded-xl p-4 shadow-sm hover:shadow-md transition">
        <h3 className="text-green-200 font-semibold text-lg mb-3 flex items-center">
          ✅ Used Features <span className="ml-2 text-sm text-green-300">({used.length})</span>
        </h3>
        {used.length > 0 ? (
          <ul className="list-disc list-inside text-sm space-y-1 text-green-100">
            {used.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-400 italic">No features used in this period.</p>
        )}
      </div>

      {/* Unused Features */}
      <div className="bg-rose-200/10 border border-rose-300/20 rounded-xl p-4 shadow-sm hover:shadow-md transition">
        <h3 className="text-rose-200 font-semibold text-lg mb-3 flex items-center">
          ❌ Unused Features <span className="ml-2 text-sm text-rose-300">({unused.length})</span>
        </h3>
        {unused.length > 0 ? (
          <ul className="list-disc list-inside text-sm space-y-1 text-rose-100">
            {unused.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-400 italic">All features have been used!</p>
        )}
      </div>
    </div>
  );
}
